import React from 'react'
import Map from './Map'
import { Link } from 'react-router-dom'
import Swal from 'sweetalert2'
import { useTranslation } from 'react-i18next';
const ContactTwoArea = () => {
    const { t, i18n } = useTranslation();
    return (
        <>
            <section id="contact_area" className="pb-5">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6">
                        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3631.575927208687!2d54.3667803!3d24.4654942!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5e6618588616c1%3A0xa3da25b1441c86c4!2zQWRhbSZFdmUgU3BlY2lhbGl6ZWQgTWVkaWNhbCBDZW50ZXIgfCBDb3NtZXRpY3MgfCDZhdix2YPYsiDYp9iv2YUg2YjYrdmI2KfYoSDYp9mE2LfYqNmKINin2YTYqtiu2LXYtdmKINin2YTYqtis2YXZitmE2Yo!5e0!3m2!1sen!2sin!4v1677604067817!5m2!1sen!2sin" width="100%"
                            height="90%"
                            style={{ border: 0 }}
                            loading="lazy" allowfullscreen referrerpolicy="no-referrer-when-downgrade" />
                        </div>
                        <div className="col-lg-6">
                            <div className="left_side_contact contact_info_wrapper">
                                <ul>
                                    <li className="address_location">
                                        <div className="contact_widget ">
                                            <i className="fa fa-map-marker"></i>
                                            <p>{t('addressline1')} <br />{t('addressline2')} <br />{t('addressline3')}</p>
                                        </div>
                                    </li>
                                    <li className="address_location">


                                        <div className="contact_widget">
                                            <i className="fa fa-phone"></i>
                                            <a href="tel:+97126219996">{t('addressline4')} <br />{t('addressline5')}</a>
                                           
                                        </div>
                                        
                                    </li>
                                    <li className="address_location">
                                        <div className="contact_widget">
                                            <i className="fa fa-envelope"></i>
                                            <a href="mailto:info@aecmc.com">{t('addressline6')}</a>
                                            
                                        </div>
                                        
                                    </li>
                                </ul>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default ContactTwoArea